import Vue from 'vue';
import VueRouter from 'vue-router';

// 导入组件
import home from '@/views/home';
import game from '@/views/game';
import shiting from '@/views/shiting';
import shitingDetail from '@/views/shitingDetail';
import course from '@/views/course';
import courseDetail from '@/views/courseDetail';
import wxCourseDetail from '@/views/wxCourseDetail';
import test from '@/views/test';
import testList from '@/views/testList';
import testDetail from '@/views/testDetail';
import exam from '@/views/exam';
import tool from '@/views/tool';
import login from '@/views/login';
import select from '@/views/select';
import webview from '@/views/webview';
import my from '@/views/my';
import classReport from '@/views/classReport';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: login
  },
  {
    path: '/login',
    component: login
  },
	{
	  path: '/select',
	  component: select
	},
  {
    path: '/home',
    component: home
  },
	{
	  path: '/game',
	  component: game
	},
	{
	  path: '/shiting',
	  component: shiting
	},
	{
	  path: '/shitingDetail',
	  component: shitingDetail
	},
	{
	  path: '/course',
	  component: course
	},
	{
    path: '/courseDetail',
    component: courseDetail
  },
  {
    path: '/wxCourseDetail',
    component: wxCourseDetail
  },
	{
	  path: '/test',
	  component: test
	},
	{
	  path: '/testList',
	  component: testList
	},
	{
	  path: '/testDetail',
	  component: testDetail
	},
	{
	  path: '/exam',
	  component: exam
	},
	{
	  path: '/tool',
	  component: tool
	},
  {
    path: '/webview',
    component: webview
  },
  {
    path: '/my',
    component: my
  },
  {
    path: '/classReport',
    component: classReport,
    meta: { requiresAuth: false } // 支持免登
  },
];

const router = new VueRouter({
  mode: 'hash', // 可选项：'hash'（默认）或 'history'
  routes
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
};

// 路由守卫
router.beforeEach(async (to, from, next) => {
  next();
});

export default router;
